import React, { useEffect, useState } from "react";
import VelkieLayout from "../VelkieLayout";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { useNavigate } from "react-router-dom";
import { useTabIndicator } from "../../../component/useTabIndicator";
import { AnimatePresence, motion } from "framer-motion";
import { isEmpty, startCase } from "lodash";
import moment from "moment";
const CurrentBet = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [tab, setTab] = useState("Exchange");
  const [select, setSelect] = useState([]);
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);

  const mergeBetType = (data, key) => {
    return data.flatMap((event) =>
      (event[key] || []).map((bet) => ({
        ...bet,
        eventName: event.eventName,
        gameType: event.gameType,
        eventDateTime: event.eventDateTime,
        eventId: event.eventId,
        seriesId: event.seriesId,
      })),
    );
  };
  const getCurrentBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets,
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results?.length > 0) {
          setData({
            Exchange: mergeBetType(response_users.results, "betList"),
            Fancybet: mergeBetType(response_users.results, "sessionBetList"),
            Bookmaker: mergeBetType(response_users.results, "bookmakerList"),
            Fancybet: mergeBetType(response_users.results, "sessionBetList"),
            Sportsbook: mergeBetType(
              response_users.results,
              "sportBookBetList",
            ),
          });
        }
      }
    }
  };
  useEffect(() => {
    getCurrentBets();
  }, []);

  const header = ["Exchange", "Bookmaker", "Fancybet", "Sportsbook", "Parlay"];
  return (
    <VelkieLayout>
      <div className="pb-20 relative" data-v-58b8c71f="">
        <div
          className="mb-20"
          data-v-732d8950=""
          style={{
            "--1344c9d1": `${indicatorStyle?.width || 57}px`,
            "--914528c2": `translateX(${indicatorStyle?.x || 7}px)`,
          }}
        >
          <header
            className="h-12 p-3 bg-secondary text-global-font-on-dark text-14 flex items-center justify-center"
            data-v-732d8950=""
          >
            Current Bets
            <div
              onClick={() => navigate("/sports-velki")}
              className="icon-close text-16 absolute right-4"
            />
          </header>
          <section
            className="tab-wrapper relative bg-black-300 overflow-x-scroll"
            data-v-732d8950=""
          >
            <div
              className="h-full inline-block"
              data-v-732d8950=""
              style={{
                transform: "translateX(0px) translateY(0px) translateZ(1px)",
                transitionDuration: "0ms",
                transitionProperty: "transform",
                transitionTimingFunction: "cubic-bezier(0.165, 0.84, 0.44, 1)",
              }}
            >
              <ul
                ref={containerRef}
                className="ml-2 mr-1 w-full h-12 flex flex-nowrap justify-start items-center"
                data-v-732d8950=""
                style={{
                  pointerEvents: "auto",
                }}
              >
                {header?.map((res, index) => {
                  return (
                    <li
                      onClick={() => {
                        setTab(res);
                        setActiveIndex(index);
                      }}
                      className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                      data-v-732d8950=""
                    >
                      {res}
                    </li>
                  );
                })}

                <motion.div
                  className="tab-indicator absolute left-0 bottom-1.5 bg-global-font-on-light rounded-full"
                  data-v-732d8950=""
                />
              </ul>
            </div>
          </section>

          <div data-v-732d8950 className="content px-4 py-4">
            {data[tab]?.length > 0 ? (
              data[tab]?.map((res) => {
                return (
                  <div data-v-732d8950>
                    <section data-v-732d8950 className="mb-2">
                      <header className="bg-black-300 flex justify-center items-center rounded-t-8px">
                        <div className="py-2 px-4 text-center leading-5 break-all">
                          <span className="text-13">
                            {startCase(res?.gameType)}
                          </span>
                          <i className="icon-triangle-black-600 inline-block align-baseline" />
                          <span className="text-13 font-bold">
                            {res?.eventName}
                          </span>
                          <i className="icon-triangle-black-600 inline-block align-baseline" />
                          <span className="text-13">
                            {tab == "Exchange" ? "Match Odds" : tab}
                          </span>
                        </div>
                      </header>
                      <section className="bg-white">
                        <div className="divide-y divide-black-300">
                          <div className="p-2 flex items-center">
                            <div
                              className={`shrink-0 w-50px h-8 back relative inline-block leading-loose mr-2 font-bold text-center bg-back rounded-full text-13 bg-${
                                res?.type == "No"
                                  ? "lay"
                                  : res?.type == "Yes"
                                    ? "back"
                                    : res?.betType
                              }`}
                            >
                              {startCase(res?.betType || res?.type)}
                            </div>
                            <span className="flex items-center text-13 font-bold min-h-28px leading-tight break-all">
                              {res?.teamName ||
                                res?.fancyName ||
                                res?.runnerName}
                            </span>
                          </div>
                          <div className="grid grid-cols-3 divide-x divide-black-300">
                            <div className="p-2 flex-1">
                              <div className="text-10">Odds req.</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {!isEmpty(res?.betType)
                                  ? res?.bhav
                                  : `${res?.betRun}/${res?.bhav}`}
                              </div>
                            </div>
                            <div className="p-2 flex-1">
                              <div className="text-10">Avg. Odds</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {!isEmpty(res?.betType)
                                  ? res?.bhav
                                  : `${res?.betRun}/${res?.bhav}`}
                              </div>
                            </div>
                            <div className="p-2 flex-1">
                              <div className="label text-10">Matched (BDT)</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {res?.amount}
                              </div>
                            </div>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Bet ID</span>
                            <span className="pl-1 text-black-600">
                              {res?.matchBetId || res?.sessionBetId}
                            </span>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Bet Placed</span>
                            <span className="pl-1 text-black-600">
                              {moment(res?.timeInserted).format(
                                "YYYY-MM-DD HH:MM:SS",
                              )}
                            </span>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Matched Date</span>
                            <span className="pl-1 text-black-600">
                              {moment(res?.eventDateTime).format(
                                "YYYY-MM-DD HH:MM:SS",
                              )}
                            </span>
                          </div>
                        </div>
                      </section>
                      {select.includes(res?._id) && (
                        <section>
                          <div className="bg-black-200 divide-y divide-black-400">
                            <div className="row second flex border-b border-black-400 bg-black-400 p-2 text-12">
                              <span className="w-1/3">Bet Taken</span>
                              <span className="pl-1">
                                {moment(res?.timeInserted).format(
                                  "YYYY-MM-DD HH:MM:SS",
                                )}
                              </span>
                            </div>
                            <div className="grid grid-cols-3 divide-x divide-black-400">
                              <div className="p-2 flex-1">
                                <div className="text-10">Odds req.</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {!isEmpty(res?.betType)
                                    ? res?.bhav
                                    : `${res?.betRun}/${res?.bhav}`}
                                </div>
                              </div>
                              <div className="p-2 flex-1">
                                <div className="text-10">Odds Matched</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {!isEmpty(res?.betType)
                                    ? res?.bhav
                                    : `${res?.betRun}/${res?.bhav}`}
                                </div>
                              </div>
                              <div className="p-2 flex-1">
                                <div className="text-10">Stake (BDT)</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {res?.amount}
                                </div>
                              </div>
                            </div>
                            {res?.betType !== "back" && (
                              <div className="flex p-2 text-12">
                                <span className="w-1/3">Liability (BDT)</span>
                                <span className="pl-1 text-error">
                                  ({res?.amount})
                                </span>
                              </div>
                            )}
                          </div>
                        </section>
                      )}
                      <footer
                        onClick={() => {
                          if (select.includes(res?._id)) {
                            setSelect((prev) => {
                              return prev?.filter((item) => {
                                return item != res?._id;
                              });
                            });
                          } else {
                            setSelect((prev) => {
                              return [...prev, res?._id];
                            });
                          }
                        }}
                      >
                        <div className="h-2 rounded-b-lg transition-colors duration-300 bg-black-400" />
                        <div className="h-4 rounded-b-lg w-90px mx-auto flex justify-center transition-colors duration-300 bg-black-400">
                          <span
                            className={`icon-arrow-down-sencodary relative -top-1 text-black transition-transform origin-center duration-300 transform ${select.includes(res?._id) ? "rotate-180" : ""}`}
                          />
                        </div>
                      </footer>
                    </section>
                  </div>
                );
              })
            ) : (
              <div
                data-v-732d8950
                className="flex justify-center items-center py-48"
              >
                <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                  <div
                    alt
                    className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                  />
                  <div>No Data</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </VelkieLayout>
  );
};

export default CurrentBet;
